import * as fs from 'fs';
import * as path from 'path';
import { JestToGherkin } from './JestToGherkin';
export * from './JestToGherkin';
/**
 * Read from the given path and create Jest to Gherkin transpiler instance.
 * @param pathTestsInput {string} path to the TypeScript testing code in Jest.
 * @returns Jest to Gherkin transpiler instance, which compiles TypeScript testing code in Jest.
 */ function createTranspiler(pathTestsInput) {
    const source = fs.readFileSync(pathTestsInput).toString();
    const transpiler = new JestToGherkin();
    transpiler.fileName = path.basename(pathTestsInput);
    const _o = transpiler.transpile(source, {
        fileName: pathTestsInput
    }).outputText;
    return transpiler;
}
/**
 * Read from the given path of Jest testing code and compose Gherkin source code.
 * @param options {{pathTestsInput: string}}: String path to the TypeScript testing code in Jest
 * @returns Composed Gherkin source code.
 */ export function compose(options) {
    const { pathTestsInput } = options;
    const transpiler = createTranspiler(pathTestsInput);
    return transpiler.outputCode();
}
/**
 *
 * @param options {{pathTestsInput: string}}: String path to the TypeScript testing code in Jest
 * @returns
 */ export function generateComments(options) {
    const { pathTestsInput } = options;
    const transpiler = createTranspiler(pathTestsInput);
    return transpiler.generateComments();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwiaWdub3JlTGlzdCI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W119